import React, { useEffect, useRef, useState } from 'react'
import useStateRef from 'react-usestateref'
import Helper from '../Helper'
import { APPLICATION_JSON, SUCCESS } from '../../middleware/types'
import CbQuickOrderSuccessModal from './CbQuickOrderSuccessModal'
import { getProfileDetailsAction } from '../../middleware/getProfileDetailsAction'
import { useDispatch, useSelector } from 'react-redux'
import { updateProfileDetailsAction } from '../../middleware/updateProfileDetailsAction'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'

const CbQuickOrder = ({ containerObject, templateName, contentId, dataZone }) => {
    const [uploadDocRowCount, setUploadDocRowCount, uploadDocRowCountRef] = useStateRef(10)
    const [orderList, setOrderList, orderListRef] = useStateRef()
    const [count, setCount, countRef] = useStateRef(0)
    const [errorMessage, setErrorMessage, errorMessageRef] = useStateRef()
    const [uploadDocHtmlData, setUploadDocHtmlData] = useState([])
    const [cartDetails, setCartDetails] = useState('')
    const [isQuickOrderCompleted, setIsQuickOrderCompleted, isQuickOrderCompletedRef] = useStateRef('false')
    const [showCartText, setShowCartText, showCartTextRef] = useStateRef("true")
    const dispatch = useDispatch();
    const formRef = useRef(null);
    const modalFormRef = useRef(null);
    const loaderStatus = useSelector(state => state.getLoaderStatus.loaderStatus)
//call vastpops data like this. And this the global vastpops window.vastpopsData()
    // useEffect(() => {
    //     if (typeof window.vastpopsData === "function" && document.readyState !== 'loading' && window.location.pathname == "/catalogs/quickorder") {
    //         console.log("Vastpops.js CbQuickOrder");
    //         window.vastpopsData();
    //     } else {
    //         console.log("window.vastpopsData is not a function.CbQuickOrder");
    //     }
    // }, []);
    
    const handleFileDelete = (event) => {
        event.preventDefault();
        var rowCount = document.getElementById("row-count").value
        const regex = /^[0-9]+$/;

        if (!regex.test(rowCount)) {
            rowCount = 1;
        }
        if (uploadDocRowCountRef.current > 1) {
            var noOfRows = parseInt(uploadDocRowCountRef.current) + parseInt(rowCount);
            if (noOfRows > 150) {
                noOfRows = 150;
            }
            setUploadDocRowCount(noOfRows);
        }
        if (uploadDocRowCountRef.current >= 150) {
            document.getElementById("labelForAdd").classList.add("d-none");
            document.getElementById("row-count").classList.add("d-none");
            document.getElementById("labelForMoreRows").classList.add("d-none");
            document.getElementById("assign").classList.add("d-none");
            document.getElementById("quick-add-row").innerHTML = "Maximum of 300 item numbers has been reached"
        }
        document.getElementById("row-count").value = "1"
    }


    async function handleQuickOrder() {
       
        var actionUrl = "api/rest/cb/shopping-list/quick-order-list";
        var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        var res = await Helper.fetchCallFunction(Url, "GET", false, APPLICATION_JSON, null);
        if (res.result == "success") {
            setOrderList(res.response)
            console.log('orderListRef.current?.length...',orderListRef.current?.length);
            
            if(Math.ceil(orderListRef.current?.length/2) > 10){
                setUploadDocRowCount(Math.ceil(orderListRef.current?.length/2));
            }
            console.log('res.response..',res.response);
        //    handleUploadDocRowCount();
        } else {
            setOrderList();
        //    handleUploadDocRowCount();

        }
    
        handleUploadDocRowCount();
    

    }

    function handleUploadDocRowCount() {
        console.log('handleUploadDocRowCount called...');
        console.log('uploadDocRowCountRef...',uploadDocRowCountRef.current);
        var elements = [];
        var lRow = 0;
        var rRow = 1;
        for (var i = 1; i < uploadDocRowCountRef.current; i++) {
            if(i <=149){
            lRow = rRow + 1;
            rRow = lRow + 1;
            elements.push(
                <div key={`tax-document-${i + 1}`} id={`tax-document-${i + 1}`} className="row border-bottom pb-2 mb-2">
                    <div className="col-12 col-md-6">
                        <div className="row">
                            <div className="col-8 col-md-8">
                                <div className="row g-1">
                                    <label for="staticEmail" className="col-sm-4 col-form-label fw-bold text-md-end">
                                    </label>
                                    <div className="col-sm-8">
                                        {console.log("lRow",lRow)}
                                        {console.log("rRow",rRow)}
                                        {console.log(",orderListRef.current", orderListRef.current && orderListRef.current[lRow])}
                                        {console.log("uploadDocRowCountRef.current orderListRef", orderListRef.current && orderListRef.current[lRow])}
                                        <input type="text" className="form-control" id={`item_${i + lRow}`} name={`item_${i + lRow}`} onBlur={handleBlur} defaultValue={orderListRef.current && orderListRef.current[lRow] && orderListRef.current[lRow].loadItem ? orderListRef.current[lRow].loadItem : ""} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-4 col-md-4">
                                <div className="row g-1">
                                    <label for="staticEmail" className="col-sm-4 col-form-label fw-bold text-md-end">
                                    </label><div className="col-sm-8">
                                        <input type="text" className="form-control" id={`qty_${i + lRow}`} name={`qty_${i + lRow}`} maxlength="2" onChange={handleChange} defaultValue={orderListRef.current && orderListRef.current[lRow] && orderListRef.current[lRow].loadQty ? orderListRef.current[lRow].loadQty : ""} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="row">
                            <div className="col-8 col-md-8">
                                <div className="row g-1">
                                    <label for="staticEmail" className="col-sm-4 col-form-label fw-bold text-md-end">
                                    </label><div className="col-sm-8">
                                    {console.log(",orderListRef.current", orderListRef.current && orderListRef.current[rRow])}
                                        {console.log("uploadDocRowCountRef.current orderListRef", orderListRef.current && orderListRef.current[rRow])}
                                        <input type="text" className="form-control" name={`item_${i + rRow}`} id={`item_${i + rRow}`} onBlur={handleBlur} defaultValue={orderListRef.current && orderListRef.current[rRow] && orderListRef.current[rRow].loadItem ? orderListRef.current[rRow].loadItem : ""} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-4 col-md-4">
                                <div className="row g-1">
                                    <label for="staticEmail" className="col-sm-4 col-form-label fw-bold text-md-end">
                                    </label>
                                    <div className="col-sm-8">
                                        <input type="text" className="form-control" id={`qty_${i + rRow}`} name={`qty_${i + rRow}`} maxlength="2" onChange={handleChange} defaultValue={orderListRef.current && orderListRef.current[rRow] && orderListRef.current[rRow].loadQty ? orderListRef.current[rRow].loadQty : ""} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
            }else{
                document.getElementById("quick-add-row").innerHTML = "Your file has exceeded the 300 product number limit, Only the first 300 products were loaded."
                break;
            }
        }
        setUploadDocHtmlData(elements)

    }

    useEffect(() => {
        
    handleUploadDocRowCount();

    }, [uploadDocRowCountRef.current])

    const clearErrMsg = () => {
        document.getElementById("cbSuccessModalTitle").classList.remove("d-none");
        document.getElementById("cbSuccessModalTitle").classList.add("d-block");
        document.getElementById("alert-div").classList.remove("d-block");
        document.getElementById("alert-div").classList.add("d-none");
    }



    function handleFormEmpty(e) {
        document.querySelector('#quick-order-import-modal').addEventListener('hidden.bs.modal', function (e) {
            modalFormRef.current.reset();
        })
    }


    useEffect(() => {
        if (loaderStatus == true) {
			console.log("log in quickOrder page loader true");
		} else {
			console.log("log in quickOrder page loader false");
        handleQuickOrder();
        handleFormEmpty()
        }

    }, [])

    async function handleQuickAdd(e) {
        e.preventDefault()
        if (isQuickOrderCompletedRef.current === 'false') {
            setIsQuickOrderCompleted('true');
            clearErrMsg();
            var formData = new FormData(e.target);
            const formValue = Object.fromEntries(formData.entries());
            var itemList = [];
            var qtyList = [];
            var flag = false;
            Object.entries(formValue).map(([key, value], keyIndex) => {

                if (key.includes('item')) {
                    if (value !== "") {
                        flag = true;
                        itemList.push(value.trim());
                    }
                }
                if (flag) {
                    if (key.includes('qty')) {
                        if (value !== "") {
                            qtyList.push(value);
                        } else {
                            qtyList.push(1);
                        }
                        flag = false;
                    }
                }
            })
            if (itemList.length > 0) {
                var actionUrl = "api/rest/cb/cart/quick-order-pad";
                var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
                var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
                    skuIdsList: itemList.join(","),
                    qtyList: qtyList.join(",")
                }))
                var cartDetails = (JSON.parse(res.response)).response.response
                if (res.result === "success") {
                    setCartDetails(cartDetails)
                    setShowCartText("true")
                    //updating mini cart count
                    dispatch(updateProfileDetailsAction(true,"cart"));

                    document.getElementById("quick-order-message-error-div").classList.remove("d-block");
                    document.getElementById("quick-order-message-error-div").classList.add("d-none");
                    document.getElementById("quickAddToCartModalId").click()
                    formRef.current.reset();
                    if (cartDetails.invalidProducts.length != 0) {
                        document.getElementById("alert-div").classList.remove("d-none");
                        document.getElementById("alert-div").classList.add("d-block");
                    } else {
                        console.log("cartDetails.invalidProducts.length", cartDetails.invalidProducts.length);
                    }
                    setIsQuickOrderCompleted('false');
                    handleQuickOrder();

                } else {
                    setShowCartText("false")
                    setCartDetails((JSON.parse(res.response)).response)
                    document.getElementById("quick-order-message-error-div").classList.remove("d-block");
                    document.getElementById("quick-order-message-error-div").classList.add("d-none");
                    document.getElementById("quickAddToCartModalId").click()
                    //inside modal
                    document.getElementById("cbSuccessModalTitle").classList.remove("d-block");
                    document.getElementById("cbSuccessModalTitle").classList.add("d-none");
                    document.getElementById("alert-div").classList.remove("d-none");
                    document.getElementById("alert-div").classList.add("d-block");
                    setIsQuickOrderCompleted('false');
                }
            } else {
                console.log('itemList...,', itemList);
                setIsQuickOrderCompleted('false');
                // document.getElementById("quickAddToCartModalId").click()
                document.getElementById("quick-order-message-error-div").classList.remove("d-none");
                document.getElementById("quick-order-message-error-div").classList.add("d-block");
                document.getElementById("item_empty_error").innerHTML = "<p>Please enter at least one Item Number.</p> <p>There were no items selected to add to the order.</p>"

            }
        }
    }

    //to convert the inputs as uppercase
    const handleBlur = (event) => {
        var field = event.target.id;
        var input = event.target.value;
        if (field === "row-count") {
            if (input === "") {
                event.target.value = 1;
            }
        } else {
            event.target.value = input.toUpperCase();
        }
    }

    //to avoid alphabets and special characters in quantity and add row field
    const handleChange = (event) => {
        const regex = /^[0-9]+$/;
        const input = event.currentTarget.value;

        if (!regex.test(input)) {
            event.target.value = input.replace(/\D/g, '');
        }
    }
    async function handleImportList(event) {
        event.preventDefault();
        var actionUrl = event.target.getAttribute('action');
        var formData = new FormData(event.target);
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/shopping-list/${actionUrl}`, {
            credentials: "include",
            method: "POST",
            enctype: "multipart/form-data",
            body: formData
        }).then(res => res.json())
            .then(res => {
                console.log("reshandleImportList", res);
                if (res.result === "success") {
                    modalFormRef.current.reset();
                    formRef.current.reset();
                     handleQuickOrder();
                    setCount(0)
                    setErrorMessage()
                    document.getElementById("quickOrderCloseModal").click();
                } else {
                    setCount(0)
                    modalFormRef.current.reset();
                    setErrorMessage(res.response)
                }
            })
    }
    function handlePrintPage() {
        window.print()
    }

    function handleCount() {
        if (count == 0) {
            setCount(1)
        }else{
           
            setErrorMessage("Please select a valid file (.xls is recommended) and include at least one item number on the file.")
        }
    }
    return (
        <>
            <div class="row align-items-center justify-content-between">
                <div class="col-md-11">
                    <nav className="c-breadcrumb" aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                        </ol>
                    </nav>
                </div>
                <div class="col-12 col-md-1 d-none d-lg-block">
                    <button class="btn btn-light c-print-btn text-end" type="button" onClick={handlePrintPage}>
                        <i class="bi bi-printer-fill" aria-hidden="true"></i>Print
                    </button>
                </div>
            </div>
            <div id="quickOrderBody" className="row justify-content-center px-0">
                {/* {successMsgState ?
                    <div class={`alert mt-3 ${successMsgState && successMsgState.tempB2IMsg ? 'alert-danger d-block' : successMsgState && successMsgState.accountSuccCreateMsg ? 'alert-success d-block' : 'd-none'} `} role="alert">
                        {successMsgState && successMsgState.tempB2IMsg ? successMsgState.tempB2IMsg :
                            successMsgState && successMsgState.accountSuccCreateMsg ? successMsgState.accountSuccCreateMsg : ''}
                    </div>
                    : ''} */}

                <div id="quick-order-message-error-div" className="d-none alert alert-danger login-error-msg">
                    <div id="item_empty_error"></div>
                </div>
                <div className="col-12 col-md-10">
                    <form method="" name="" onSubmit={handleQuickAdd} action="" id="quickAdd" className="c-account-page quick-add-form" data-hs-cf-bound="" ref={formRef}>

                        <div className="text-left mt-3">
                            <h1 className="c-account-heading">Quick Order Form</h1>
                        </div>
                        <div id="errors"></div>
                        <div className="text-left mt-3 mb-4">
                            <p className="c-regular-text">Add items to your Cart by entering item/catalog numbers and quantities and clicking the Continue button at the bottom of the page. You can also import items from Microsoft® Excel using the Import an <strong>Excel List</strong> option at the bottom of the page.</p>
                            <Link to="/landing/college/materials-for-popular-biology-labs?intid=quickord_t_collegebiolists" className="fw-bold">Save time with lab lists »</Link>
                        </div>

                        <div className="text-end border-bottom pb-2 mb-2">
                            <p className="import-model-xls text-end linkStyle mb-0" data-bs-toggle="modal" data-bs-target="#quick-order-import-modal" onClick={() => handleCount()}>Import an Excel List</p>
                        </div>

                        <div className="row border-bottom pb-2 mb-2">
                            <div className="col-12 col-md-6">
                                <div className="row">
                                    <div className="col-8 col-md-8">
                                        <div className="row g-1">
                                            <label for="staticEmail" className="col-sm-4 col-form-label fw-bold text-md-end">Item #:</label>
                                            <div className="col-sm-8">
                                                <input id="item_0" type="text" name="item_1" className="form-control" onBlur={handleBlur} defaultValue={orderListRef.current && orderListRef.current[0] && orderListRef.current[0].loadItem ? orderListRef.current[0].loadItem : ""} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-4 col-md-4">
                                        <div className="row g-1">
                                            <label for="staticEmail" className="col-sm-4 col-form-label fw-bold text-md-end">Qty:</label>
                                            <div className="col-sm-8">
                                                <input id="qty_0" type="text" className="form-control" name="qty_1" maxlength="2" onChange={handleChange} defaultValue={orderListRef.current && orderListRef.current[0] && orderListRef.current[0].loadQty ? orderListRef.current[0].loadQty : ""} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-md-6">
                                <div className="row">
                                    <div className="col-8 col-md-8">
                                        <div className="row g-1">
                                            <label for="staticEmail" className="col-sm-4 col-form-label fw-bold text-md-end">Item #:</label>
                                            <div className="col-sm-8">
                                                <input id="item_1" type="text" name="item_2" className="form-control" onBlur={handleBlur} defaultValue={orderListRef.current && orderListRef.current[1] && orderListRef.current[1].loadItem ? orderListRef.current[1].loadItem : ""} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-4 col-md-4">
                                        <div className="row g-1">
                                            <label for="staticEmail" className="col-sm-4 col-form-label fw-bold text-md-end">Qty:</label>
                                            <div className="col-sm-8">
                                                <input id="qty_1" type="text" name="qty_2" className="form-control" maxlength="2" onChange={handleChange} defaultValue={orderListRef.current && orderListRef.current[1] && orderListRef.current[1].loadQty ? orderListRef.current[1].loadQty : ""} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div id="newQuickOrderRow">
                            <div className="">{uploadDocHtmlData ? uploadDocHtmlData : ""}</div>
                        </div>

                        <div className="c-list-bar">
                            <div className="c-quick-add-row" id="quick-add-row">
                                <label className="fw-normal" id="labelForAdd">
                                    Add
                                </label>
                                <input type="text" className="c-details-search-qty form-control" id="row-count" defaultValue="1" onBlur={handleBlur} onFocus={(event) => { event.target.value = "" }} />
                                <label className="m-hide" id="labelForMoreRows">
                                    more rows
                                </label>
                                <input type="button" className="btn-primary c-shop-btn" value="Add" id="assign" onClick={handleFileDelete} />
                            </div>
                        </div>

                        <div className="row justify-content-end mb-5">
                            <div className="col-md-2 d-grid quick-order-continue">
                                <button className="btn btn-primary block" id="continue" type="submit" >Continue</button>
                            </div>
                        </div>

                    </form>
                    <CbQuickOrderSuccessModal textFlag={showCartTextRef.current} cartDetails={cartDetails} />
                    <button data-bs-target="#quickAddToCartModal" id="quickAddToCartModalId" data-bs-toggle="modal" data-bs-dismiss="modal" className="d-none" ></button>
                </div>
            </div>
            {/* Quick Order Import List */}
            <div class="modal fade c-modal show" id="quick-order-import-modal" tabindex="-1" aria-labelledby="defaultModalLabel" aria-modal="true" role="dialog">
                <div class="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-md">
                    <div class="modal-content">
                        <button id="quickOrderCloseModal" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                        </button>
                        <div class="modal-body">
                            <body class="bg-white" id="modal" style={{marginBottom:"6.5rem"}}>
                                <div id="middle">
                                    <form method="post" id="fileUpload" action="import-quick-order" class="col-12" onSubmit={handleImportList} ref={modalFormRef}>
                                        <div class="container-fluid c-modal importItem-modal-body">
                                            <div class="row">
                                                <div class="col-12 mb-3">
                                                    <h3 class="modal-title mb-3" id="quick-order-import-modal-label">
                                                        Import Items
                                                    </h3>
                                                    <h4 class="modal-sub-heading">
                                                        Follow the steps below to import multiple products using an Microsoft® Excel spreadsheet.
                                                    </h4>
                                                </div>
                                                {errorMessageRef.current ?
                                                    <div class="col-12">
                                                        <div class="alert alert-danger d-block" role="alert">
                                                            {errorMessageRef.current}
                                                        </div>
                                                    </div>
                                                    : ""}
                                                <div class="col-12 mb-3">
                                                    <ol class="importItem-modal-steps">
                                                        <li>
                                                            <a href="/document/quick-order-import-template.xls">
                                                                <span class="fwb">Click here to download the Microsoft® Excel template</span>
                                                            </a>
                                                        </li>
                                                        <li>Enter item numbers in Column A and quantities needed in Column B.
                                                            <span class="fst-italic">Please do not include any prefixes, dashes, or other punctuation in the item numbers.</span>
                                                        </li>
                                                        <li>Save the file on your computer. <span class="fwb">Excel 97-2003 (.xls)</span> is recommended.
                                                        </li>
                                                        <li>
                                                            <label for="formFile" class=" mb-2 d-block">Click the <span class="fwb">Browse</span> button below to locate the file.
                                                            </label>
                                                            <input name="quickOrderFile" id="uploadedFile" type="file" class="file-input mb-2" />
                                                        </li>
                                                        <li>Click the Upload File button below to import the file.</li>
                                                    </ol>
                                                </div>
                                                <div class="row justify-content-end form-submit">
                                                    <div class="col-auto">
                                                        <input type="submit" class="btn btn-primary" value="Upload File" id="subUpload" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </body>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CbQuickOrder